import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import { SO_LUONG_VB_DI } from "@/constants/vanBanDi";
import { SO_LUONG_HSCV } from "@/constants/hoSoCongViec";
import { hasPermissionUser } from "@/utils/permissionUtils";
import {
  ROUTE_NAME,
  MENU_ROUTE_NAME,
  SO_LUONG_VAN_BAN_DEN,
  PERMISSION_NAME,
  PERMISSION_NAME_VAN_BAN,
  PERMISSION_NAME_HSLT,
} from "@/constants/constants";
import {
  getValueFromStorageByKey,
  LOCAL_STORAGE_KEY,
  setValueToStorageByKey,
} from "@/utils/localStorage";

import LayoutLogin from "@/layouts/LayoutLogin";

const TrangChu = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/TrangChu"], () => {
    resolve(require("@/views/TrangChu"));
  });
};

const TrangChuaCoQuyen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/TrangChuaCoQuyen"], () => {
    resolve(require("@/views/TrangChuaCoQuyen"));
  });
};

const NotFoundPage = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/NotFoundPage"], () => {
    resolve(require("@/views/NotFoundPage"));
  });
};

const TrangDangNhap = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/dang-nhap/TrangDangNhap"], () => {
    resolve(require("@/views/dang-nhap/TrangDangNhap"));
    resolve(require("@/views/dang-nhap/TrangDangNhap"));
  });
};

const TrangVanBanDi = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangVanBanDi"], () => {
    resolve(require("@/views/van-ban-di/TrangVanBanDi"));
  });
};

const TrangQuanLyMauDuThao = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/quan-tri-he-thong/TrangQuanLyMauDuThao"], () => {
    resolve(require("@/views/quan-tri-he-thong/TrangQuanLyMauDuThao"));
  });
};

const TrangChiTietMauDuThao = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/quan-tri-he-thong/TrangChiTietMauDuThao"], () => {
    resolve(require("@/views/quan-tri-he-thong/TrangChiTietMauDuThao"));
  });
};

const TrangCauHinhHeThong = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/quan-tri-he-thong/TrangCauHinhHeThong"], () => {
    resolve(require("@/views/quan-tri-he-thong/TrangCauHinhHeThong"));
  });
};
const TrangQuanLyDonViNopLuu = (resolve) => {
  require.ensure(["@/views/quan-tri-he-thong/TrangQuanLyDonViNopLuu"], () => {
    resolve(require("@/views/quan-tri-he-thong/TrangQuanLyDonViNopLuu"));
  });
};

const TrangCauHinhUyQuyen = (resolve) => {
  require.ensure(["@/views/quan-tri-he-thong/TrangCauHinhUyQuyen"], () => {
    resolve(require("@/views/quan-tri-he-thong/TrangCauHinhUyQuyen"));
  });
};

const TrangQuanLyUyQuyen = (resolve) => {
  require.ensure(["@/views/quan-tri-he-thong/TrangQuanLyUyQuyen"], () => {
    resolve(require("@/views/quan-tri-he-thong/TrangQuanLyUyQuyen"));
  });
};

const WordOnlineVBDi = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/WordOnline"], () => {
    resolve(require("@/views/van-ban-di/WordOnline"));
  });
};

const PdfOnlineVBDi = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/PdfOnline"], () => {
    resolve(require("@/views/van-ban-di/PdfOnline"));
  });
};

const TrangChoCapSo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangChoCapSo"], () => {
    resolve(require("@/views/van-ban-di/TrangChoCapSo"));
  });
};

const TrangChoBoCapSo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangChoBoCapSo"], () => {
    resolve(require("@/views/van-ban-di/TrangChoBoCapSo"));
  });
};

const TrangQuanLyGiuSo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangQuanLyGiuSo"], () => {
    resolve(require("@/views/van-ban-di/TrangQuanLyGiuSo"));
  });
};

const TrangQuanLyDoiSo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangQuanLyDoiSo"], () => {
    resolve(require("@/views/van-ban-di/TrangQuanLyDoiSo"));
  });
};

const TrangChiTietCapSo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangChiTietCapSo"], () => {
    resolve(require("@/views/van-ban-di/TrangChiTietCapSo"));
  });
};

const TrangTrinhKyTiepTheo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangTrinhKyTiepTheo"], () => {
    resolve(require("@/views/van-ban-di/TrangTrinhKyTiepTheo"));
  });
};

const TrangNhanSo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangNhanSo"], () => {
    resolve(require("@/views/van-ban-di/TrangNhanSo"));
  });
};

const TrangChoBanHanh = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangChoBanHanh"], () => {
    resolve(require("@/views/van-ban-di/TrangChoBanHanh"));
  });
};

const TrangVanBanBiLoi = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangVanBanBiLoi"], () => {
    resolve(require("@/views/van-ban-di/TrangVanBanBiLoi"));
  });
};

const TrangChoTrinhKy = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangChoTrinhKy"], () => {
    resolve(require("@/views/van-ban-di/TrangChoTrinhKy"));
  });
};

const TrangYeuCauTraLai = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangYeuCauTraLai"], () => {
    resolve(require("@/views/van-ban-di/TrangYeuCauTraLai"));
  });
};

const TrangChoXuLy = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangChoXuLy"], () => {
    resolve(require("@/views/van-ban-di/TrangChoXuLy"));
  });
};

const TrangHoSoCongViec = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-cong-viec/TrangHoSoCongViec"], () => {
    resolve(require("@/views/ho-so-cong-viec/TrangHoSoCongViec"));
  });
};

const TrangTraCuuHSCV = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-cong-viec/TrangTraCuu"], () => {
    resolve(require("@/views/ho-so-cong-viec/TrangTraCuu"));
  });
};

const TrangChoXuLyHSCV = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-cong-viec/TrangChoXuLy"], () => {
    resolve(require("@/views/ho-so-cong-viec/TrangChoXuLy"));
  });
};

const TrangDangXuLyHSCV = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-cong-viec/TrangDangXuLy"], () => {
    resolve(require("@/views/ho-so-cong-viec/TrangDangXuLy"));
  });
};

const TrangChoPhanXuLyHSCV = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-cong-viec/TrangChoPhanXuLyHSCV"], () => {
    resolve(require("@/views/ho-so-cong-viec/TrangChoPhanXuLyHSCV"));
  });
};

const TrangDaTraLaiHSCV = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-cong-viec/TrangDaTraLaiHSCV"], () => {
    resolve(require("@/views/ho-so-cong-viec/TrangDaTraLaiHSCV"));
  });
};

const TrangBiTraLaiHSCV = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-cong-viec/TrangBiTraLaiHSCV"], () => {
    resolve(require("@/views/ho-so-cong-viec/TrangBiTraLaiHSCV"));
  });
};

const TrangChoChoYKienHSCV = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-cong-viec/TrangChoChoYKienHSCV"], () => {
    resolve(require("@/views/ho-so-cong-viec/TrangChoChoYKienHSCV"));
  });
};

const TrangDaChoYKienHSCV = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-cong-viec/TrangDaChoYKienHSCV"], () => {
    resolve(require("@/views/ho-so-cong-viec/TrangDaChoYKienHSCV"));
  });
};

const TrangDaKetThucHSCV = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-cong-viec/TrangDaKetThucHSCV"], () => {
    resolve(require("@/views/ho-so-cong-viec/TrangDaKetThucHSCV"));
  });
};

const TrangDaXuLy = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangDaXuLy"], () => {
    resolve(require("@/views/van-ban-di/TrangDaXuLy"));
  });
};

const TrangDaTraLai = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangDaTraLai"], () => {
    resolve(require("@/views/van-ban-di/TrangDaTraLai"));
  });
};

const TrangDaBanHanh = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangDaBanHanh"], () => {
    resolve(require("@/views/van-ban-di/TrangDaBanHanh"));
  });
};

const TrangTraCuu = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangTraCuu"], () => {
    resolve(require("@/views/van-ban-di/TrangTraCuu"));
  });
};

const TrangThemMoiHoSoCongViec = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-cong-viec/TrangThemMoiHoSoCongViec"], () => {
    resolve(require("@/views/ho-so-cong-viec/TrangThemMoiHoSoCongViec"));
  });
};

const TrangXemHoSoCongViec = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-cong-viec/TrangXemHoSoCongViec"], () => {
    resolve(require("@/views/ho-so-cong-viec/TrangXemHoSoCongViec"));
  });
};

const TrangSuaHoSoCongViec = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-cong-viec/TrangSuaHoSoCongViec"], () => {
    resolve(require("@/views/ho-so-cong-viec/TrangSuaHoSoCongViec"));
  });
};

const WordOnlineHSCV = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-cong-viec/WordOnline"], () => {
    resolve(require("@/views/ho-so-cong-viec/WordOnline"));
  });
};

const PdfOnlineHSCV = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-cong-viec/PdfOnline"], () => {
    resolve(require("@/views/ho-so-cong-viec/PdfOnline"));
  });
};

const TrangNoiBo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangNoiBo"], () => {
    resolve(require("@/views/van-ban-di/TrangNoiBo"));
  });
};

const TrangChoYKien = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangChoYKien"], () => {
    resolve(require("@/views/van-ban-di/TrangChoYKien"));
  });
};

const TrangDaChoYKien = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangDaChoYKien"], () => {
    resolve(require("@/views/van-ban-di/TrangDaChoYKien"));
  });
};

const ChiTietVanBanDi = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangChiTietVanBanDi"], () => {
    resolve(require("@/views/van-ban-di/TrangChiTietVanBanDi"));
  });
};

//
const VanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangVanBanDen"));
  });
};

const TrangXemLuongXuLyVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangXemLuongXuLy"], () => {
    resolve(require("@/views/van-ban-den/TrangXemLuongXuLy"));
  });
};

const WordOnlineVBDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/WordOnline"], () => {
    resolve(require("@/views/van-ban-den/WordOnline"));
  });
};

const PdfOnlineVBDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/PdfOnline"], () => {
    resolve(require("@/views/van-ban-den/PdfOnline"));
  });
};

const TrangXemLuongXuLyVanBanDi = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangXemLuongVanBanDi"], () => {
    resolve(require("@/views/van-ban-di/TrangXemLuongVanBanDi"));
  });
};

const TrangXemLuongNhiemVu = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/nhiem-vu/TrangXemLuongNhiemVu"], () => {
    resolve(require("@/views/nhiem-vu/TrangXemLuongNhiemVu"));
  });
};

const TrangTraCuuVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangTraCuuVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangTraCuuVanBanDen"));
  });
};

const TrangTraCuuPhamViVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangTraCuuPhamViVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangTraCuuPhamViVanBanDen"));
  });
};

const TrangChoVaoSoVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangChoVaoSoVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangChoVaoSoVanBanDen"));
  });
};

const TrangChoXuLyVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangChoXuLyVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangChoXuLyVanBanDen"));
  });
};
const TrangYeuCauThuHoiVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangYeuCauThuHoiVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangYeuCauThuHoiVanBanDen"));
  });
};

const TrangYeuCauCapNhatVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangYeuCauCapNhatVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangYeuCauCapNhatVanBanDen"));
  });
};

const TrangBaoCaoLanhDao = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangBaoCaoLanhDao"], () => {
    resolve(require("@/views/van-ban-den/TrangBaoCaoLanhDao"));
  });
};

const TrangDangXuLyVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangDangXuLyVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangDangXuLyVanBanDen"));
  });
};

const TrangDaXuLyVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangDaXuLyVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangDaXuLyVanBanDen"));
  });
};

const TrangBiTraLaiVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangBiTraLaiVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangBiTraLaiVanBanDen"));
  });
};

const TrangDaTraLaiVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangDaTraLaiVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangDaTraLaiVanBanDen"));
  });
};

const TrangBiTraLaiVanBanDi = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-di/TrangBiTraLai"], () => {
    resolve(require("@/views/van-ban-di/TrangBiTraLai"));
  });
};

const TrangThuHoiVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangThuHoiVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangThuHoiVanBanDen"));
  });
};

const TrangTraLaiVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangTraLaiVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangTraLaiVanBanDen"));
  });
};

const TrangChoYKienVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangChoYKienVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangChoYKienVanBanDen"));
  });
};

const TrangDaChoYKienVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangDaChoYKienVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangDaChoYKienVanBanDen"));
  });
};

const TrangNhanDeBietVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangNhanDeBietVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangNhanDeBietVanBanDen"));
  });
};

const TrangTaoMoiVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangTaoMoiVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangTaoMoiVanBanDen"));
  });
};

const TrangChiTietVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangChiTietVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangChiTietVanBanDen"));
  });
};

const TaoPAKN = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/components/pages/van-ban-den/TaoPAKN"], () => {
    resolve(require("@/components/pages/van-ban-den/TaoPAKN"));
  });
};
const TrangSuaVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/van-ban-den/TrangSuaVanBanDen"], () => {
    resolve(require("@/views/van-ban-den/TrangSuaVanBanDen"));
  });
};

const TrangNhiemVu = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/nhiem-vu/TrangNhiemVu"], () => {
    resolve(require("@/views/nhiem-vu/TrangNhiemVu"));
  });
};

const TrangLuuTruDienTu = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/luu-tru-dien-tu/TrangLuuTruDienTu"], () => {
    resolve(require("@/views/luu-tru-dien-tu/TrangLuuTruDienTu"));
  });
};

const TrangNhiemVuCaNhan = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/nhiem-vu/TrangNhiemVuCaNhan"], () => {
    resolve(require("@/views/nhiem-vu/TrangNhiemVuCaNhan"));
  });
};

const TrangNhiemVuDonVi = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/nhiem-vu/TrangNhiemVuDonVi"], () => {
    resolve(require("@/views/nhiem-vu/TrangNhiemVuDonVi"));
  });
};
const TrangNhiemVuDonViGiao = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/nhiem-vu/TrangNhiemVuDonViGiao"], () => {
    resolve(require("@/views/nhiem-vu/TrangNhiemVuDonViGiao"));
  });
};
const TrangNhiemVuCPGiao = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/nhiem-vu/TrangNhiemVuCpGiao"], () => {
    resolve(require("@/views/nhiem-vu/TrangNhiemVuCpGiao"));
  });
};
const TrangNhiemVuBoGiao = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/nhiem-vu/TrangNhiemVuBoGiao"], () => {
    resolve(require("@/views/nhiem-vu/TrangNhiemVuBoGiao"));
  });
};

const TrangQuanTriHeThong = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/quan-tri-he-thong/TrangQuanTriHeThong"], () => {
    resolve(require("@/views/quan-tri-he-thong/TrangQuanTriHeThong"));
  });
};

const TrangDanhSachQuanLyLogHeThong = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(
    ["@/views/quan-tri-he-thong/TrangDanhSachQuanLyHeThong"],
    () => {
      resolve(require("@/views/quan-tri-he-thong/TrangDanhSachQuanLyHeThong"));
    }
  );
};

const TrangQuanLyDanhMucCRUD = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/quan-tri-he-thong/TrangQuanLyDanhMucCRUD"], () => {
    resolve(require("@/views/quan-tri-he-thong/TrangQuanLyDanhMucCRUD"));
  });
};

const TrangDanhSachLoaiSoVanBan = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(
    ["@/views/quan-tri-he-thong/TrangDanhSachLoaiSoVanBan"],
    () => {
      resolve(require("@/views/quan-tri-he-thong/TrangDanhSachLoaiSoVanBan"));
    }
  );
};

const TrangDanhSachSoVanBan = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/quan-tri-he-thong/TrangDanhSachSoVanBan"], () => {
    resolve(require("@/views/quan-tri-he-thong/TrangDanhSachSoVanBan"));
  });
};

const TrangDanhSachLoaiVanBan = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/quan-tri-he-thong/TrangDanhSachLoaiVanBan"], () => {
    resolve(require("@/views/quan-tri-he-thong/TrangDanhSachLoaiVanBan"));
  });
};

const TrangDanhSachNhomLamViec = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/quan-tri-he-thong/TrangDanhSachNhomLamViec"], () => {
    resolve(require("@/views/quan-tri-he-thong/TrangDanhSachNhomLamViec"));
  });
};

const TrangDanhSachDeMuc = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/quan-tri-he-thong/TrangDanhSachDeMuc"], () => {
    resolve(require("@/views/quan-tri-he-thong/TrangDanhSachDeMuc"));
  });
};

const TrangQuanLyLinhVuc = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/quan-tri-he-thong/TrangQuanLyLinhVuc"], () => {
    resolve(require("@/views/quan-tri-he-thong/TrangQuanLyLinhVuc"));
  });
};

const TrangDanhSachDonViNgoai = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/quan-tri-he-thong/TrangDanhSachDonViNgoai"], () => {
    resolve(require("@/views/quan-tri-he-thong/TrangDanhSachDonViNgoai"));
  });
};

const TrangQuanLyNhomCongViec = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/quan-tri-he-thong/TrangQuanLyNhomCongViec"], () => {
    resolve(require("@/views/quan-tri-he-thong/TrangQuanLyNhomCongViec"));
  });
};

const TrangQuanLyTemplate = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/quan-tri-he-thong/TrangQuanLyTemplate"], () => {
    resolve(require("@/views/quan-tri-he-thong/TrangQuanLyTemplate"));
  });
};

const TrangImportNhiemVu = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/nhiem-vu/TrangImportNhiemVu"], () => {
    resolve(require("@/views/nhiem-vu/TrangImportNhiemVu"));
  });
};

const TrangTaoNhiemVu = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/nhiem-vu/TrangTaoNhiemVu"], () => {
    resolve(require("@/views/nhiem-vu/TrangTaoNhiemVu"));
  });
};

const TrangChiTietNhiemVu = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/nhiem-vu/TrangChiTietNhiemVu"], () => {
    resolve(require("@/views/nhiem-vu/TrangChiTietNhiemVu"));
  });
};

const TrangCapNhatNhiemVu = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/nhiem-vu/TrangCapNhatNhiemVu"], () => {
    resolve(require("@/views/nhiem-vu/TrangCapNhatNhiemVu"));
  });
};

const BaoCao = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/bao-cao/TrangBaoCao"], () => {
    resolve(require("@/views/bao-cao/TrangBaoCao"));
  });
};

const TrangBaoCaoVanBanDen = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/bao-cao/TrangBaoCaoVanBanDen"], () => {
    resolve(require("@/views/bao-cao/TrangBaoCaoVanBanDen"));
  });
};

const TrangBaoCaoVanBanDi = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/bao-cao/TrangBaoCaoVanBanDi"], () => {
    resolve(require("@/views/bao-cao/TrangBaoCaoVanBanDi"));
  });
};
const TrangBaoCaoTongHop = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/bao-cao/TrangBaoCaoTongHop"], () => {
    resolve(require("@/views/bao-cao/TrangBaoCaoTongHop"));
  });
};
const TrangBaoCaoNhiemVu = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/bao-cao/TrangBaoCaoNhiemVu"], () => {
    resolve(require("@/views/bao-cao/TrangBaoCaoNhiemVu"));
  });
};
const TrangHoSoLuuTru = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-luu-tru/TrangHoSoLuuTru"], () => {
    resolve(require("@/views/ho-so-luu-tru/TrangHoSoLuuTru"));
  });
};

const TrangDanhMucHoSo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-luu-tru/TrangDanhMucHoSo"], () => {
    resolve(require("@/views/ho-so-luu-tru/TrangDanhMucHoSo"));
  });
};

const TrangHoSo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-luu-tru/TrangHoSo"], () => {
    resolve(require("@/views/ho-so-luu-tru/TrangHoSo"));
  });
};

const TrangThemMoiDanhMucHoSo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-luu-tru/TrangThemMoiDanhMucHoSo"], () => {
    resolve(require("@/views/ho-so-luu-tru/TrangThemMoiDanhMucHoSo"));
  });
};

const SettingDonViNopDanhMuc = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(
    [
      "@/components/pages/ho-so-luu-tru/danh-muc-ho-so/tinh-hinh-nop-danh-muc/SettingTinhHinhNopDanhMuc",
    ],
    () => {
      resolve(
        require("@/components/pages/ho-so-luu-tru/danh-muc-ho-so/tinh-hinh-nop-danh-muc/SettingTinhHinhNopDanhMuc")
      );
    }
  );
};

const TrangTaoMoiHoSo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-luu-tru/TrangTaoMoiHoSo.vue"], () => {
    resolve(require("@/views/ho-so-luu-tru/TrangTaoMoiHoSo.vue"));
  });
};

const HeThong = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/he-thong/TrangHeThong"], () => {
    resolve(require("@/views/he-thong/TrangHeThong"));
  });
};

const TrangDanhSachNhomChucVu = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(
    ["@/views/quan-ly-nhom-chuc-vu/TrangDanhSachNhomChucVu"],
    () => {
      resolve(require("@/views/quan-ly-nhom-chuc-vu/TrangDanhSachNhomChucVu"));
    }
  );
};

const TrangCapNhatNhomChucVu = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(
    ["@/views/quan-ly-nhom-chuc-vu/TrangCapNhatNhomChucVu"],
    () => {
      resolve(require("@/views/quan-ly-nhom-chuc-vu/TrangCapNhatNhomChucVu"));
    }
  );
};

const TrangChiTietNhomChucVu = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(
    ["@/views/quan-ly-nhom-chuc-vu/TrangChiTietNhomChucVu"],
    () => {
      resolve(require("@/views/quan-ly-nhom-chuc-vu/TrangChiTietNhomChucVu"));
    }
  );
};

const RedirectPage = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/components/common/BaseRedirect"], () => {
    resolve(require("@/components/common/BaseRedirect"));
  });
};

const ChiTietDanhMucHoSo = (resolve) => {
  // require.ensure is Webpack's special syntax for a code-split point.
  require.ensure(["@/views/ho-so-luu-tru/ChiTietDanhMucHoSo"], () => {
    resolve(require("@/views/ho-so-luu-tru/ChiTietDanhMucHoSo"));
  });
};

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/van-ban-den/cho-xu-ly",
    },
    {
      path: "/redirect",
      name: "/redirect",
      component: RedirectPage,
      meta: { layout: LayoutLogin },
    },
    { path: "*", redirect: "/" },
    {
      path: "/404",
      name: "Not Found",
      component: NotFoundPage,
      isShowLeftMenu: false,
      expand: false,
    },
    {
      path: ROUTE_NAME.CHUA_CO_QUYEN,
      component: TrangChuaCoQuyen,
      isShowLeftMenu: false,
      expand: false,
    },
    {
      path: ROUTE_NAME.DANG_NHAP,
      pathAbsolute: ROUTE_NAME.DANG_NHAP,
      name: ROUTE_NAME.DANG_NHAP,
      component: TrangDangNhap,
      meta: { layout: LayoutLogin },
    },
    {
      path: ROUTE_NAME.VAN_BAN_DEN.NAME,
      name: ROUTE_NAME.VAN_BAN_DEN.NAME,
      pathAbsolute:
        ROUTE_NAME.VAN_BAN_DEN.NAME + ROUTE_NAME.VAN_BAN_DEN.CHO_VAO_SO,
      permissionAbsolute: PERMISSION_NAME.CHO_VAO_SO_VAN_BAN_DEN,
      menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.NAME,
      component: VanBanDen,
      icon: "download",
      svgIcon: "van-ban",
      appName: ["QLVB"],
      chucNang: "VAN_BAN_DEN",
      props: true,
      isShowLeftMenu: true,
      expand: false,
      children: [
        {
          path: ROUTE_NAME.VAN_BAN_DEN.TRA_CUU_OLD,
          name: ROUTE_NAME.VAN_BAN_DEN.TRA_CUU_OLD,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.TRA_CUU,
          component: TrangTraCuuVanBanDen,
          icon: "search",
          isShowLeftMenu: false,
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.XEM_LUONG,
          name: ROUTE_NAME.VAN_BAN_DEN.XEM_LUONG,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.TRA_CUU,
          component: TrangXemLuongXuLyVanBanDen,
          icon: "search",
          isShowLeftMenu: false,
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.CHO_VAO_SO,
          name: ROUTE_NAME.VAN_BAN_DEN.CHO_VAO_SO,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.CHO_VAO_SO,
          component: TrangChoVaoSoVanBanDen,
          soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.CHO_VAO_SO,
          icon: "list-alt",
          meta: {
            soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.CHO_VAO_SO,
            permission: [
              PERMISSION_NAME_VAN_BAN.VAN_BAN_DEN_VAO_SO_DIEN_TU_BANG_TAY,
              PERMISSION_NAME_VAN_BAN.VAN_BAN_DEN_VAO_SO_VAN_BAN_GIAY,
              PERMISSION_NAME_VAN_BAN.VAN_BAN_DEN_VAO_SO_TU_DONG,
            ],
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.CHO_XU_LY,
          name: ROUTE_NAME.VAN_BAN_DEN.CHO_XU_LY,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.CHO_XU_LY,
          soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.CHO_XU_LY,
          component: TrangChoXuLyVanBanDen,
          icon: "clock",
          meta: {
            soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.CHO_XU_LY,
            permission: PERMISSION_NAME.CHO_XU_LY_VAN_BAN_DEN,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.BAO_CAO_LANH_DAO,
          name: ROUTE_NAME.VAN_BAN_DEN.BAO_CAO_LANH_DAO,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.BAO_CAO_LANH_DAO,
          soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.BAO_CAO_LANH_DAO,
          component: TrangBaoCaoLanhDao,
          icon: "clock",
          meta: {
            soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.BAO_CAO_LANH_DAO,
            permission: PERMISSION_NAME.NHAN_BAO_CAO_LANH_DAO,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.DANG_XU_LY,
          name: ROUTE_NAME.VAN_BAN_DEN.DANG_XU_LY,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.DANG_XU_LY,
          soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.DANG_XU_LY,
          component: TrangDangXuLyVanBanDen,
          icon: "sync-alt",
          meta: {
            soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.DANG_XU_LY,
            permission: PERMISSION_NAME.DANG_XU_LY_VAN_BAN_DEN,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.DA_XU_LY,
          name: ROUTE_NAME.VAN_BAN_DEN.DA_XU_LY,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.DA_XU_LY,
          soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.DA_XU_LY,
          component: TrangDaXuLyVanBanDen,
          icon: "check-square",
          meta: {
            soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.DA_XU_LY,
            permission: PERMISSION_NAME.DA_XU_LY_VAN_BAN_DEN,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.BI_TRA_LAI,
          name: ROUTE_NAME.VAN_BAN_DEN.BI_TRA_LAI,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.BI_TRA_LAI,
          soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.TRA_LAI,
          component: TrangBiTraLaiVanBanDen,
          icon: "check-square",
          meta: {
            soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.TRA_LAI,
            permission: PERMISSION_NAME.DA_XU_LY_VAN_BAN_DEN,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.DA_TRA_LAI,
          name: ROUTE_NAME.VAN_BAN_DEN.DA_TRA_LAI,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.TRA_LAI,
          soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.DA_TRA_LAI,
          component: TrangDaTraLaiVanBanDen,
          icon: "check-square",
          meta: {
            soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.DA_TRA_LAI,
            permission: PERMISSION_NAME.DA_TRA_LAI_VAN_BAN_DEN,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.THU_HOI,
          name: ROUTE_NAME.VAN_BAN_DEN.THU_HOI,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.THU_HOI,
          soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.THU_HOI,
          component: TrangThuHoiVanBanDen,
          icon: "undo",
          meta: {
            soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.THU_HOI,
            permission: PERMISSION_NAME.BI_THU_HOI_VAN_BAN_DEN,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.CHO_Y_KIEN,
          name: ROUTE_NAME.VAN_BAN_DEN.CHO_Y_KIEN,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.CHO_Y_KIEN,
          soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.CHO_Y_KIEN,
          isShowLeftMenu: !IS_DESKTOP,
          component: TrangChoYKienVanBanDen,
          icon: "comment-dots",
          meta: {
            soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.CHO_Y_KIEN,
            permission: PERMISSION_NAME.CHO_CHO_Y_KIEN_VAN_BAN_DEN,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.DA_CHO_Y_KIEN,
          name: ROUTE_NAME.VAN_BAN_DEN.DA_CHO_Y_KIEN,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.DA_CHO_Y_KIEN,
          soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.DA_CHO_Y_KIEN,
          isShowLeftMenu: !IS_DESKTOP,
          component: TrangDaChoYKienVanBanDen,
          icon: "comments",
          meta: {
            soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.DA_CHO_Y_KIEN,
            permission: PERMISSION_NAME.DA_CHO_Y_KIEN_VAN_BAN_DEN,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.NHAN_DE_BIET,
          name: ROUTE_NAME.VAN_BAN_DEN.NHAN_DE_BIET,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.NHAN_DE_BIET,
          soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.NHAN_DE_BIET,
          component: TrangNhanDeBietVanBanDen,
          icon: "book",
          meta: {
            soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.NHAN_DE_BIET,
            permission: PERMISSION_NAME.NHAN_DE_BIET_VAN_BAN_DEN,
          },
        },
        {
          // Yêu cầu cập nhật
          path: ROUTE_NAME.VAN_BAN_DEN.YEU_CAU_CAP_NHAT,
          name: ROUTE_NAME.VAN_BAN_DEN.YEU_CAU_CAP_NHAT,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.YEU_CAU_CAP_NHAT,
          component: TrangYeuCauCapNhatVanBanDen,
          meta: {
            soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.YEU_CAU_CAP_NHAT,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.YEU_CAU_THU_HOI,
          name: ROUTE_NAME.VAN_BAN_DEN.YEU_CAU_THU_HOI,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.YEU_CAU_THU_HOI,
          soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.YEU_CAU_THU_HOI,
          component: TrangYeuCauThuHoiVanBanDen,
          icon: "clock",
          meta: {
            soLuongVanBanDen: SO_LUONG_VAN_BAN_DEN.YEU_CAU_THU_HOI,
            permission: PERMISSION_NAME.YEU_CAU_THU_HOI_VAN_BAN_DEN,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.TAO_MOI,
          name: ROUTE_NAME.VAN_BAN_DEN.TAO_MOI,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.TAO_MOI,
          component: TrangTaoMoiVanBanDen,
          isShowLeftMenu: false,
          expand: false,
          icon: "",
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.SUA,
          name: ROUTE_NAME.VAN_BAN_DEN.SUA,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.SUA,
          component: TrangSuaVanBanDen,
          isShowLeftMenu: false,
          expand: false,
          icon: "",
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.CHI_TIET_VAN_BAN_DEN,
          name: ROUTE_NAME.VAN_BAN_DEN.CHI_TIET_VAN_BAN_DEN,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.CHI_TIET_VAN_BAN_DEN,
          component: TrangChiTietVanBanDen,
          isShowLeftMenu: false,
          icon: "",
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.TAO_PAKN,
          name: ROUTE_NAME.VAN_BAN_DEN.TAO_PAKN,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.TAO_PAKN,
          component: TaoPAKN,
          isShowLeftMenu: false,
          icon: "",
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.XEM,
          name: ROUTE_NAME.VAN_BAN_DEN.CHI_TIET_VAN_BAN_DEN,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.CHI_TIET_VAN_BAN_DEN,
          component: TrangChiTietVanBanDen,
          isShowLeftMenu: false,
          icon: "",
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.WORD_ONLINE,
          name: ROUTE_NAME.VAN_BAN_DEN.WORD_ONLINE,
          isShowLeftMenu: false,
          component: WordOnlineVBDen,
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.EXCEL_ONLINE,
          name: ROUTE_NAME.VAN_BAN_DEN.EXCEL_ONLINE,
          isShowLeftMenu: false,
          component: WordOnlineVBDen,
        },
        {
          path: ROUTE_NAME.VAN_BAN_DEN.PDF_ONLINE,
          name: ROUTE_NAME.VAN_BAN_DEN.PDF_ONLINE,
          isShowLeftMenu: false,
          component: PdfOnlineVBDen,
        },
        {
          //tra cứu phạm vi
          path: ROUTE_NAME.VAN_BAN_DEN.TRA_CUU,
          name: ROUTE_NAME.VAN_BAN_DEN.TRA_CUU,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DEN.TRA_CUU,
          component: TrangTraCuuPhamViVanBanDen,
          icon: "search",
          meta: {
            permission: PERMISSION_NAME.TRA_CUU_VAN_BAN_DEN,
          },
        },
      ],
    },
    {
      path: ROUTE_NAME.VAN_BAN_DI.NAME,
      name: ROUTE_NAME.VAN_BAN_DI.NAME,
      pathAbsolute:
        ROUTE_NAME.VAN_BAN_DI.NAME + ROUTE_NAME.VAN_BAN_DI.CHO_XU_LY,
      permissionAbsolute: PERMISSION_NAME.TRINH_KY_VAN_BAN_DI,
      menuName: MENU_ROUTE_NAME.VAN_BAN_DI.NAME,
      component: TrangVanBanDi,
      icon: "sign-out-alt",
      svgIcon: "van-ban",
      isShowLeftMenu: true,
      appName: ["QLVB"],
      chucNang: "VAN_BAN_DI",
      expand: false,
      children: [
        {
          path: ROUTE_NAME.VAN_BAN_DI.XEM_LUONG,
          name: ROUTE_NAME.VAN_BAN_DI.XEM_LUONG,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.TRA_CUU,
          component: TrangXemLuongXuLyVanBanDi,
          icon: "search",
          isShowLeftMenu: false,
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.CHO_TRINH_KY,
          name: ROUTE_NAME.VAN_BAN_DI.CHO_TRINH_KY,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.CHO_TRINH_KY,
          soLuong: SO_LUONG_VB_DI.CHO_TRINH_KY,
          component: TrangChoTrinhKy,
          icon: "pen-alt",
          meta: {
            permission: PERMISSION_NAME.TRINH_KY_VAN_BAN_DI,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.CHO_XU_LY,
          name: ROUTE_NAME.VAN_BAN_DI.CHO_XU_LY,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.CHO_XU_LY,
          soLuong: SO_LUONG_VB_DI.CHO_XU_LY,
          component: TrangChoXuLy,
          icon: "clock",
          meta: {
            permission: PERMISSION_NAME.TRINH_XU_LY_VAN_BAN,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.DA_XU_LY,
          name: ROUTE_NAME.VAN_BAN_DI.DA_XU_LY,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.DA_XU_LY,
          soLuong: SO_LUONG_VB_DI.DA_XU_LY,
          component: TrangDaXuLy,
          icon: "check-square",
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.CHO_BO_CAP_SO,
          name: ROUTE_NAME.VAN_BAN_DI.CHO_BO_CAP_SO,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.CHO_BO_CAP_SO,
          soLuong: SO_LUONG_VB_DI.CHO_BO_CAP_SO,
          component: TrangChoBoCapSo,
          icon: "list-alt",
          meta: {
            // permission: PERMISSION_NAME.SUA_VAN_BAN_CHO_CAP_SO,
            permission: PERMISSION_NAME.TRINH_KY_VAN_BAN_DI, // Hótfix để hiện thị menu "Chờ bộ cấp số cho user chưa phân quyền đúng"
          },
        },

        {
          path: ROUTE_NAME.VAN_BAN_DI.CHO_CAP_SO,
          name: ROUTE_NAME.VAN_BAN_DI.CHO_CAP_SO,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.CHO_CAP_SO,
          soLuong: SO_LUONG_VB_DI.CHO_CAP_SO,
          component: TrangChoCapSo,
          icon: "list-alt",
          meta: {
            permission: PERMISSION_NAME.SUA_VAN_BAN_CHO_CAP_SO,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.CHO_BAN_HANH,
          name: ROUTE_NAME.VAN_BAN_DI.CHO_BAN_HANH,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.CHO_BAN_HANH,
          soLuong: SO_LUONG_VB_DI.CHO_BAN_HANH,
          component: TrangChoBanHanh,
          icon: "sync-alt",
          meta: {
            permission: PERMISSION_NAME.BAN_HANH,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.DA_BAN_HANH,
          name: ROUTE_NAME.VAN_BAN_DI.DA_BAN_HANH,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.DA_BAN_HANH,
          soLuong: SO_LUONG_VB_DI.DA_BAN_HANH,
          component: TrangDaBanHanh,
          icon: "paper-plane",
          meta: {
            permission: PERMISSION_NAME.DA_BAN_HANH,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.NOI_BO,
          name: ROUTE_NAME.VAN_BAN_DI.NOI_BO,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.NOI_BO,
          soLuong: SO_LUONG_VB_DI.NOI_BO,
          component: TrangNoiBo,
          icon: "tags",
          meta: {
            permission: PERMISSION_NAME.VAN_BAN_DI_NOI_BO,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.YEU_CAU_TRA_LAI,
          name: ROUTE_NAME.VAN_BAN_DI.YEU_CAU_TRA_LAI,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.YEU_CAU_TRA_LAI,
          soLuong: SO_LUONG_VB_DI.YEU_CAU_TRA_LAI,
          component: TrangYeuCauTraLai,
          icon: "pen-alt",
          isShowLeftMenu: false,
          meta: {
            permission: PERMISSION_NAME.YEU_CAU_TRA_LAI,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.BI_TRA_LAI,
          name: ROUTE_NAME.VAN_BAN_DI.BI_TRA_LAI,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.BI_TRA_LAI,
          soLuong: SO_LUONG_VB_DI.BI_TRA_LAI,
          component: TrangBiTraLaiVanBanDi,
          icon: "pen-alt",
          meta: {
            permission: PERMISSION_NAME.BI_TRA_LAI,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.DA_TRA_LAI,
          name: ROUTE_NAME.VAN_BAN_DI.DA_TRA_LAI,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.DA_TRA_LAI,
          soLuong: SO_LUONG_VB_DI.DA_TRA_LAI,
          component: TrangDaTraLai,
          icon: "undo",
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.CHO_Y_KIEN,
          name: ROUTE_NAME.VAN_BAN_DI.CHO_Y_KIEN,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.CHO_Y_KIEN,
          soLuong: SO_LUONG_VB_DI.CHO_Y_KIEN,
          isShowLeftMenu: !IS_DESKTOP,
          component: TrangChoYKien,
          icon: "comment-dots",
          meta: {
            permission: PERMISSION_NAME.CHO_CHO_Y_KIEN_VAN_BAN_DI,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.DA_CHO_Y_KIEN,
          name: ROUTE_NAME.VAN_BAN_DI.DA_CHO_Y_KIEN,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.DA_CHO_Y_KIEN,
          soLuong: SO_LUONG_VB_DI.DA_CHO_Y_KIEN,
          isShowLeftMenu: !IS_DESKTOP,
          component: TrangDaChoYKien,
          icon: "comments",
          meta: {
            permission: PERMISSION_NAME.DA_CHO_Y_KIEN_VAN_BAN_DI,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.QUAN_LY_DOI_SO,
          name: ROUTE_NAME.VAN_BAN_DI.QUAN_LY_DOI_SO,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.QUAN_LY_DOI_SO,
          component: TrangQuanLyDoiSo,
          icon: "sync-alt",
          meta: {
            permission: PERMISSION_NAME.VAN_BAN_DI_DOI_SO,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.QUAN_LY_GIU_SO,
          name: ROUTE_NAME.VAN_BAN_DI.QUAN_LY_GIU_SO,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.QUAN_LY_GIU_SO,
          soLuong: SO_LUONG_VB_DI.QUAN_LY_GIU_SO,
          component: TrangQuanLyGiuSo,
          icon: "sync-alt",
          meta: {
            permission: PERMISSION_NAME.GIU_SO,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.CHI_TIET_CAP_SO,
          name: ROUTE_NAME.VAN_BAN_DI.CHI_TIET_CAP_SO,
          isShowLeftMenu: false,
          component: TrangChiTietCapSo,
          meta: {
            permission: PERMISSION_NAME.CAP_SO,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.SUA_VAN_BAN_CHO_BAN_HANH,
          name: ROUTE_NAME.VAN_BAN_DI.SUA_VAN_BAN_CHO_BAN_HANH,
          isShowLeftMenu: false,
          component: TrangChiTietCapSo,
          meta: {
            permission: PERMISSION_NAME.SUA_VAN_BAN_CHO_BAN_HANH,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.SAO_CHEP_VAN_BAN_CAP_SO_BAN_HANH,
          name: ROUTE_NAME.VAN_BAN_DI.SAO_CHEP_VAN_BAN_CAP_SO_BAN_HANH,
          isShowLeftMenu: false,
          component: TrangChiTietCapSo,
          meta: {
            permission: PERMISSION_NAME.SAO_CHEP_VAN_BAN_CAP_SO_BAN_HANH,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.TRINH_KY_TIEP_THEO,
          name: ROUTE_NAME.VAN_BAN_DI.TRINH_KY_TIEP_THEO,
          isShowLeftMenu: false,
          component: TrangTrinhKyTiepTheo,
          meta: {
            permission: PERMISSION_NAME.TRINH_KY_TIEO_THEO,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.NHAN_SO,
          name: ROUTE_NAME.VAN_BAN_DI.NHAN_SO,
          isShowLeftMenu: false,
          component: TrangNhanSo,
          meta: {
            permission: PERMISSION_NAME.GIU_SO,
          },
        },

        {
          path: ROUTE_NAME.VAN_BAN_DI.TAO_MOI,
          name: ROUTE_NAME.VAN_BAN_DI.TAO_MOI,
          isShowLeftMenu: false,
          component: ChiTietVanBanDi,
          meta: {
            permission: PERMISSION_NAME.TAO_VAN_BAN_TRINH_KY,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.XEM,
          name: ROUTE_NAME.VAN_BAN_DI.XEM,
          isShowLeftMenu: false,
          component: ChiTietVanBanDi,
          meta: {
            permission: PERMISSION_NAME.SUA_VAN_BAN_TRINH_KY,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.CHI_TIET_VAN_BAN_Di,
          name: ROUTE_NAME.VAN_BAN_DI.CHI_TIET_VAN_BAN_Di,
          isShowLeftMenu: false,
          component: ChiTietVanBanDi,
          meta: {
            permission: PERMISSION_NAME.UNCHECK,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.WORD_ONLINE,
          name: ROUTE_NAME.VAN_BAN_DI.WORD_ONLINE,
          isShowLeftMenu: false,
          component: WordOnlineVBDi,
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.EXCEL_ONLINE,
          name: ROUTE_NAME.VAN_BAN_DI.EXCEL_ONLINE,
          isShowLeftMenu: false,
          component: WordOnlineVBDi,
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.PDF_ONLINE,
          name: ROUTE_NAME.VAN_BAN_DI.PDF_ONLINE,
          isShowLeftMenu: false,
          component: PdfOnlineVBDi,
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.TRA_CUU,
          name: ROUTE_NAME.VAN_BAN_DI.TRA_CUU,
          menuName: MENU_ROUTE_NAME.VAN_BAN_DI.TRA_CUU,
          component: TrangTraCuu,
          icon: "search",
          meta: {
            permission: PERMISSION_NAME.TRA_CUU_VAN_BAN,
          },
        },
      ],
    },
    {
      path: ROUTE_NAME.HO_SO_CONG_VIEC.NAME,
      name: ROUTE_NAME.HO_SO_CONG_VIEC.NAME,
      pathAbsolute:
        ROUTE_NAME.HO_SO_CONG_VIEC.NAME + ROUTE_NAME.HO_SO_CONG_VIEC.CHO_XU_LY,
      permissionAbsolute: PERMISSION_NAME.HO_SO_CONG_VIEC_XEM_CHI_TIET_HO_SO,
      menuName: MENU_ROUTE_NAME.HO_SO_CONG_VIEC.NAME,
      component: TrangHoSoCongViec,
      appName: ["QLVB"],
      chucNang: "HSCV",
      icon: "book",
      svgIcon: "hscv",
      isShowLeftMenu: !IS_DESKTOP,
      expand: false,
      children: [
        {
          path: ROUTE_NAME.HO_SO_CONG_VIEC.CHO_PHAN_XU_LY,
          name: ROUTE_NAME.HO_SO_CONG_VIEC.CHO_PHAN_XU_LY,
          menuName: MENU_ROUTE_NAME.HO_SO_CONG_VIEC.CHO_PHAN_XU_LY,
          soLuongHSCV: SO_LUONG_HSCV.CHO_PHAN_XU_LY,
          component: TrangChoPhanXuLyHSCV,
          meta: {
            permission: PERMISSION_NAME.HO_SO_CONG_VIEC_XEM_CHI_TIET_HO_SO,
          },
          icon: "share",
        },
        {
          path: ROUTE_NAME.HO_SO_CONG_VIEC.CHO_XU_LY,
          name: ROUTE_NAME.HO_SO_CONG_VIEC.CHO_XU_LY,
          menuName: MENU_ROUTE_NAME.HO_SO_CONG_VIEC.CHO_XU_LY,
          soLuongHSCV: SO_LUONG_HSCV.CHO_XU_LY,
          component: TrangChoXuLyHSCV,
          meta: {
            permission: PERMISSION_NAME.HO_SO_CONG_VIEC_XEM_CHI_TIET_HO_SO,
          },
          icon: "clock",
        },
        {
          path: ROUTE_NAME.HO_SO_CONG_VIEC.DANG_THUC_HIEN,
          name: ROUTE_NAME.HO_SO_CONG_VIEC.DANG_THUC_HIEN,
          menuName: MENU_ROUTE_NAME.HO_SO_CONG_VIEC.DANG_THUC_HIEN,
          soLuongHSCV: SO_LUONG_HSCV.DANG_XU_LY,
          component: TrangDangXuLyHSCV,
          meta: {
            permission: PERMISSION_NAME.HO_SO_CONG_VIEC_XEM_CHI_TIET_HO_SO,
          },
          icon: "sync-alt",
        },
        {
          path: ROUTE_NAME.HO_SO_CONG_VIEC.DA_KET_THUC,
          name: ROUTE_NAME.HO_SO_CONG_VIEC.DA_KET_THUC,
          menuName: MENU_ROUTE_NAME.HO_SO_CONG_VIEC.DA_KET_THUC,
          soLuongHSCV: SO_LUONG_HSCV.DA_KET_THUC,
          component: TrangDaKetThucHSCV,
          meta: {
            permission: PERMISSION_NAME.HO_SO_CONG_VIEC_XEM_CHI_TIET_HO_SO,
          },
          icon: "check-square",
        },
        {
          path: ROUTE_NAME.HO_SO_CONG_VIEC.DA_TRA_LAI,
          name: ROUTE_NAME.HO_SO_CONG_VIEC.DA_TRA_LAI,
          menuName: MENU_ROUTE_NAME.HO_SO_CONG_VIEC.DA_TRA_LAI,
          soLuongHSCV: SO_LUONG_HSCV.DA_TRA_LAI,
          component: TrangDaTraLaiHSCV,
          meta: {
            permission: PERMISSION_NAME.HO_SO_CONG_VIEC_XEM_CHI_TIET_HO_SO,
          },
          icon: "reply",
        },
        {
          path: ROUTE_NAME.HO_SO_CONG_VIEC.BI_TRA_LAI,
          name: ROUTE_NAME.HO_SO_CONG_VIEC.BI_TRA_LAI,
          menuName: MENU_ROUTE_NAME.HO_SO_CONG_VIEC.BI_TRA_LAI,
          soLuongHSCV: SO_LUONG_HSCV.BI_TRA_LAI,
          component: TrangBiTraLaiHSCV,
          meta: {
            permission: PERMISSION_NAME.HO_SO_CONG_VIEC_XEM_CHI_TIET_HO_SO,
          },
          icon: "redo",
        },
        {
          path: ROUTE_NAME.HO_SO_CONG_VIEC.CHO_CHO_Y_KIEN,
          name: ROUTE_NAME.HO_SO_CONG_VIEC.CHO_CHO_Y_KIEN,
          menuName: MENU_ROUTE_NAME.HO_SO_CONG_VIEC.CHO_CHO_Y_KIEN,
          soLuongHSCV: SO_LUONG_HSCV.CHO_CHO_Y_KIEN,
          component: TrangChoChoYKienHSCV,
          meta: {
            permission: PERMISSION_NAME.HO_SO_CONG_VIEC_XEM_CHI_TIET_HO_SO,
          },
          icon: "comment-dots",
        },
        {
          path: ROUTE_NAME.HO_SO_CONG_VIEC.DA_CHO_Y_KIEN,
          name: ROUTE_NAME.HO_SO_CONG_VIEC.DA_CHO_Y_KIEN,
          menuName: MENU_ROUTE_NAME.HO_SO_CONG_VIEC.DA_CHO_Y_KIEN,
          soLuongHSCV: SO_LUONG_HSCV.DA_CHO_Y_KIEN,
          component: TrangDaChoYKienHSCV,
          meta: {
            permission: PERMISSION_NAME.HO_SO_CONG_VIEC_XEM_CHI_TIET_HO_SO,
          },
          icon: "comments",
        },
        {
          path: ROUTE_NAME.HO_SO_CONG_VIEC.THEM_MOI,
          name: ROUTE_NAME.HO_SO_CONG_VIEC.THEM_MOI,
          menuName: MENU_ROUTE_NAME.HO_SO_CONG_VIEC.THEM_MOI,
          component: TrangThemMoiHoSoCongViec,
          isShowLeftMenu: false,
          meta: {
            permission: PERMISSION_NAME.HO_SO_CONG_VIEC_THEM_MOI_HO_SO,
          },
        },
        {
          path: ROUTE_NAME.HO_SO_CONG_VIEC.XEM,
          name: ROUTE_NAME.HO_SO_CONG_VIEC.XEM,
          menuName: MENU_ROUTE_NAME.HO_SO_CONG_VIEC.XEM,
          component: TrangXemHoSoCongViec,
          isShowLeftMenu: false,
          meta: {
            permission: PERMISSION_NAME.HO_SO_CONG_VIEC_XEM_CHI_TIET_HO_SO,
          },
        },
        {
          path: ROUTE_NAME.HO_SO_CONG_VIEC.SUA,
          name: ROUTE_NAME.HO_SO_CONG_VIEC.SUA,
          menuName: MENU_ROUTE_NAME.HO_SO_CONG_VIEC.SUA,
          component: TrangSuaHoSoCongViec,
          isShowLeftMenu: false,
          meta: {
            permission: PERMISSION_NAME.HO_SO_CONG_VIEC_SUA_HO_SO,
          },
        },
        {
          path: ROUTE_NAME.HO_SO_CONG_VIEC.WORD_ONLINE,
          name: ROUTE_NAME.HO_SO_CONG_VIEC.WORD_ONLINE,
          isShowLeftMenu: false,
          component: WordOnlineHSCV,
        },
        {
          path: ROUTE_NAME.HO_SO_CONG_VIEC.EXCEL_ONLINE,
          name: ROUTE_NAME.HO_SO_CONG_VIEC.EXCEL_ONLINE,
          isShowLeftMenu: false,
          component: WordOnlineHSCV,
        },
        {
          path: ROUTE_NAME.HO_SO_CONG_VIEC.PDF_ONLINE,
          name: ROUTE_NAME.HO_SO_CONG_VIEC.PDF_ONLINE,
          isShowLeftMenu: false,
          component: PdfOnlineHSCV,
        },
        {
          path: ROUTE_NAME.HO_SO_CONG_VIEC.TRA_CUU,
          name: ROUTE_NAME.HO_SO_CONG_VIEC.TRA_CUU,
          menuName: MENU_ROUTE_NAME.HO_SO_CONG_VIEC.TRA_CUU,
          component: TrangTraCuuHSCV,
          meta: {
            permission: PERMISSION_NAME.HO_SO_CONG_VIEC_XEM_CHI_TIET_HO_SO,
          },
          icon: "search",
        },
      ],
    },
    {
      path: ROUTE_NAME.NHIEM_VU.NAME,
      name: ROUTE_NAME.NHIEM_VU.NAME,
      pathAbsolute: ROUTE_NAME.NHIEM_VU.NAME + ROUTE_NAME.NHIEM_VU.CP_GIAO,
      permissionAbsolute:
        ROUTE_NAME.NHIEM_VU.NAME + ROUTE_NAME.NHIEM_VU.CA_NHAN,
      menuName: MENU_ROUTE_NAME.NHIEM_VU.NAME,
      component: TrangNhiemVu,
      icon: "tasks",
      svgIcon: "nhiem-vu",
      chucNang: "NHIEM_VU",
      appName: ["QLNV"],
      props: true,
      isShowLeftMenu: !IS_DESKTOP,
      expand: false,
      children: [
        {
          path: ROUTE_NAME.NHIEM_VU.XEM_LUONG,
          name: ROUTE_NAME.NHIEM_VU.XEM_LUONG,
          menuName: MENU_ROUTE_NAME.NHIEM_VU.CA_NHAN,
          component: TrangXemLuongNhiemVu,
          icon: "search",
          isShowLeftMenu: false,
        },
        {
          path: ROUTE_NAME.NHIEM_VU.CP_GIAO,
          name: ROUTE_NAME.NHIEM_VU.CP_GIAO,
          menuName: MENU_ROUTE_NAME.NHIEM_VU.CP_GIAO,
          component: TrangNhiemVuCPGiao,
          icon: "user",
          meta: {
            permission: PERMISSION_NAME.DANH_SACH_NHIEM_VU_CP_GIAO,
          },
        },
        {
          path: ROUTE_NAME.NHIEM_VU.BO_GIAO,
          name: ROUTE_NAME.NHIEM_VU.BO_GIAO,
          menuName: MENU_ROUTE_NAME.NHIEM_VU.BO_GIAO,
          component: TrangNhiemVuBoGiao,
          icon: "user",
          meta: {
            permission: PERMISSION_NAME.DANH_SACH_NHIEM_VU_BO_GIAO,
          },
        },
        {
          path: ROUTE_NAME.NHIEM_VU.DON_VI_GIAO,
          name: ROUTE_NAME.NHIEM_VU.DON_VI_GIAO,
          menuName: MENU_ROUTE_NAME.NHIEM_VU.DON_VI_GIAO,
          component: TrangNhiemVuDonViGiao,
          icon: "user",
          meta: {
            permission: PERMISSION_NAME.DANH_SACH_NHIEM_VU_DON_VI_GIAO,
          },
        },
        {
          path: ROUTE_NAME.NHIEM_VU.TAO,
          name: ROUTE_NAME.NHIEM_VU.TAO,
          menuName: MENU_ROUTE_NAME.NHIEM_VU.TAO,
          component: TrangTaoNhiemVu,
          isShowLeftMenu: false,
          expand: false,
          icon: "",
        },
        {
          path: ROUTE_NAME.NHIEM_VU.CAP_NHAT,
          name: ROUTE_NAME.NHIEM_VU.CAP_NHAT,
          menuName: MENU_ROUTE_NAME.NHIEM_VU.CAP_NHAT,
          component: TrangCapNhatNhiemVu,
          isShowLeftMenu: false,
          expand: false,
          icon: "",
        },
        {
          path: ROUTE_NAME.NHIEM_VU.CA_NHAN,
          name: ROUTE_NAME.NHIEM_VU.CA_NHAN,
          menuName: MENU_ROUTE_NAME.NHIEM_VU.CA_NHAN,
          component: TrangNhiemVuCaNhan,
          icon: "user",
        },
        {
          path: ROUTE_NAME.NHIEM_VU.DON_VI,
          name: ROUTE_NAME.NHIEM_VU.DON_VI,
          menuName: MENU_ROUTE_NAME.NHIEM_VU.DON_VI,
          component: TrangNhiemVuDonVi,
          icon: "users",
        },
        {
          path: ROUTE_NAME.NHIEM_VU.CHI_TIET_CA_NHAN,
          name: ROUTE_NAME.NHIEM_VU.CHI_TIET_CA_NHAN,
          menuName: MENU_ROUTE_NAME.NHIEM_VU.CHI_TIET,
          component: TrangChiTietNhiemVu,
          isShowLeftMenu: false,
        },
        {
          path: ROUTE_NAME.NHIEM_VU.CHI_TIET_DON_VI,
          name: ROUTE_NAME.NHIEM_VU.CHI_TIET_DON_VI,
          menuName: MENU_ROUTE_NAME.NHIEM_VU.CHI_TIET,
          component: TrangChiTietNhiemVu,
          isShowLeftMenu: false,
        },
        {
          path: ROUTE_NAME.NHIEM_VU.CHI_TIET_CP_GIAO,
          name: ROUTE_NAME.NHIEM_VU.CHI_TIET_CP_GIAO,
          menuName: MENU_ROUTE_NAME.NHIEM_VU.CHI_TIET_CP_GIAO,
          component: TrangChiTietNhiemVu,
          isShowLeftMenu: false,
        },
        {
          path: ROUTE_NAME.NHIEM_VU.CHI_TIET_BO_GIAO,
          name: ROUTE_NAME.NHIEM_VU.CHI_TIET_BO_GIAO,
          menuName: MENU_ROUTE_NAME.NHIEM_VU.CHI_TIET_BO_GIAO,
          component: TrangChiTietNhiemVu,
          isShowLeftMenu: false,
        },
        {
          path: ROUTE_NAME.NHIEM_VU.CHI_TIET_DON_VI_GIAO,
          name: ROUTE_NAME.NHIEM_VU.CHI_TIET_DON_VI_GIAO,
          menuName: MENU_ROUTE_NAME.NHIEM_VU.CHI_TIET_DON_VI_GIAO,
          component: TrangChiTietNhiemVu,
          isShowLeftMenu: false,
        },
      ],
    },
    {
      path: ROUTE_NAME.LUU_TRU_DIEN_TU.NAME,
      name: ROUTE_NAME.LUU_TRU_DIEN_TU.NAME,
      pathAbsolute: ROUTE_NAME.LUU_TRU_DIEN_TU.NAME,
      permissionAbsolute: ROUTE_NAME.LUU_TRU_DIEN_TU.NAME,
      menuName: MENU_ROUTE_NAME.LUU_TRU_DIEN_TU.NAME,
      component: TrangLuuTruDienTu,
      icon: "ltdt",
      svgIcon: "ltdt",
      chucNang: "LTDT",
      appName: ["HSLT"],
      props: true,
      isShowLeftMenu: true,
      expand: false,
    },
    {
      path: ROUTE_NAME.NHIEM_VU.IMPORT,
      name: ROUTE_NAME.NHIEM_VU.IMPORT,
      pathAbsolute: ROUTE_NAME.NHIEM_VU.IMPORT,
      menuName: MENU_ROUTE_NAME.NHIEM_VU.IMPORT,
      component: TrangImportNhiemVu,
      isShowLeftMenu: false,
      expand: false,
      icon: "",
    },
    {
      pathAbsolute:
        ROUTE_NAME.HO_SO_LUU_TRU.NAME +
        ROUTE_NAME.HO_SO_LUU_TRU.DANH_MUC_HO_SO.NAME,
      path: ROUTE_NAME.HO_SO_LUU_TRU.NAME,
      name: ROUTE_NAME.HO_SO_LUU_TRU.NAME,
      menuName: MENU_ROUTE_NAME.HO_SO_LUU_TRU.NAME,
      component: TrangHoSoLuuTru,
      chucNang: "HO_SO_LUU_TRU",
      appName: ["QLVB"],
      icon: "chart-line",
      svgIcon: "hslt",
      isShowLeftMenu: false,
      expand: false,
      children: [
        {
          path: ROUTE_NAME.HO_SO_LUU_TRU.DANH_MUC_HO_SO.NAME,
          name: ROUTE_NAME.HO_SO_LUU_TRU.DANH_MUC_HO_SO.NAME,
          menuName: MENU_ROUTE_NAME.HO_SO_LUU_TRU.DANH_MUC_HO_SO.NAME,
          component: TrangDanhMucHoSo,
          icon: "sign-out-alt",
        },
        {
          path: ROUTE_NAME.HO_SO_LUU_TRU.HO_SO,
          name: ROUTE_NAME.HO_SO_LUU_TRU.HO_SO,
          menuName: MENU_ROUTE_NAME.HO_SO_LUU_TRU.HO_SO,
          component: TrangHoSo,
          icon: "sign-out-alt",
        },

        {
          path: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU.NAME,
          name: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU.NAME,
          menuName: MENU_ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU.NAME,
          component: TrangDanhMucHoSo,
          icon: "sign-out-alt",
          children: [
            {
              path: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                .YC_NOP_LUU_TAI_LIEU,
              name: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                .YC_NOP_LUU_TAI_LIEU,
              menuName:
                MENU_ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                  .YC_NOP_LUU_TAI_LIEU,
              component: TrangBaoCaoVanBanDi,
              icon: "sign-out-alt",
            },
            {
              path: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                .YC_GIU_LAI_TAI_LIEU,
              name: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                .YC_GIU_LAI_TAI_LIEU,
              menuName:
                MENU_ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                  .YC_GIU_LAI_TAI_LIEU,
              component: TrangBaoCaoVanBanDen,
              icon: "download",
            },
            {
              path: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU.MUC_LUC_HO_SO
                .NAME,
              name: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU.MUC_LUC_HO_SO
                .NAME,
              menuName:
                MENU_ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU.MUC_LUC_HO_SO
                  .NAME,
              component: TrangBaoCaoVanBanDen,
              icon: "download",
              children: [
                {
                  path: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU.MUC_LUC_HO_SO
                    .CHUA_TIEP_NHAN,
                  name: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU.MUC_LUC_HO_SO
                    .CHUA_TIEP_NHAN,
                  menuName:
                    MENU_ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                      .MUC_LUC_HO_SO.CHUA_TIEP_NHAN,
                  component: TrangBaoCaoVanBanDen,
                  icon: "download",
                },
                {
                  path: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU.MUC_LUC_HO_SO
                    .DA_TIEP_NHAN,
                  name: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU.MUC_LUC_HO_SO
                    .DA_TIEP_NHAN,
                  menuName:
                    MENU_ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                      .MUC_LUC_HO_SO.DA_TIEP_NHAN,
                  component: TrangBaoCaoVanBanDen,
                  icon: "download",
                },
              ],
            },
            {
              path: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                .BIEN_BAN_BAN_GIAO_TAI_LIEU,
              name: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                .BIEN_BAN_BAN_GIAO_TAI_LIEU,
              menuName:
                MENU_ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                  .BIEN_BAN_BAN_GIAO_TAI_LIEU,
              component: TrangHoSo,
              icon: "download",
            },
            {
              path: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                .HO_SO_VE_VIEC_THU_THAP_TAI_LIEU,
              name: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                .HO_SO_VE_VIEC_THU_THAP_TAI_LIEU,
              menuName:
                MENU_ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                  .HO_SO_VE_VIEC_THU_THAP_TAI_LIEU,
              component: TrangBaoCaoVanBanDen,
              icon: "download",
            },
            {
              path: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                .HO_SO_TAI_LIEU_DA_THU_THAP,
              name: ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                .HO_SO_TAI_LIEU_DA_THU_THAP,
              menuName:
                MENU_ROUTE_NAME.HO_SO_LUU_TRU.THU_THAP_TAI_LIEU
                  .HO_SO_TAI_LIEU_DA_THU_THAP,
              component: TrangBaoCaoVanBanDen,
              icon: "download",
            },
          ],
        },
        {
          path: ROUTE_NAME.HO_SO_LUU_TRU.KHAI_THAC_SU_DUNG_TAI_LIEU,
          name: ROUTE_NAME.HO_SO_LUU_TRU.KHAI_THAC_SU_DUNG_TAI_LIEU,
          menuName: MENU_ROUTE_NAME.HO_SO_LUU_TRU.KHAI_THAC_SU_DUNG_TAI_LIEU,
          component: TrangHoSo,
          icon: "sign-out-alt",
        },
        {
          path: ROUTE_NAME.HO_SO_LUU_TRU.NOP_LUU_TAI_LIEU,
          name: ROUTE_NAME.HO_SO_LUU_TRU.NOP_LUU_TAI_LIEU,
          menuName: MENU_ROUTE_NAME.HO_SO_LUU_TRU.NOP_LUU_TAI_LIEU,
          component: TrangHoSo,
          icon: "sign-out-alt",
        },
        {
          path: ROUTE_NAME.HO_SO_LUU_TRU.HUY_TAI_LIEU_HET_GIA_TRI,
          name: ROUTE_NAME.HO_SO_LUU_TRU.HUY_TAI_LIEU_HET_GIA_TRI,
          menuName: MENU_ROUTE_NAME.HO_SO_LUU_TRU.HUY_TAI_LIEU_HET_GIA_TRI,
          component: TrangHoSo,
          icon: "sign-out-alt",
        },
        {
          path: ROUTE_NAME.HO_SO_LUU_TRU.BAO_CAO,
          name: ROUTE_NAME.HO_SO_LUU_TRU.BAO_CAO,
          menuName: MENU_ROUTE_NAME.HO_SO_LUU_TRU.BAO_CAO,
          component: TrangHoSo,
          icon: "sign-out-alt",
        },
        {
          path:
            ROUTE_NAME.HO_SO_LUU_TRU.DANH_MUC_HO_SO.NAME +
            "/" +
            ROUTE_NAME.HO_SO_LUU_TRU.DANH_MUC_HO_SO.THEM_MOI,
          name: ROUTE_NAME.HO_SO_LUU_TRU.DANH_MUC_HO_SO.THEM_MOI,
          menuName: MENU_ROUTE_NAME.HO_SO_LUU_TRU.DANH_MUC_HO_SO.THEM_MOI,
          component: TrangThemMoiDanhMucHoSo,
          icon: "sign-out-alt",
          isShowLeftMenu: false,
        },
        {
          path:
            ROUTE_NAME.HO_SO_LUU_TRU.DANH_MUC_HO_SO.NAME +
            "/" +
            ROUTE_NAME.HO_SO_LUU_TRU.DANH_MUC_HO_SO.SUA,
          name: ROUTE_NAME.HO_SO_LUU_TRU.DANH_MUC_HO_SO.SUA,
          menuName: MENU_ROUTE_NAME.HO_SO_LUU_TRU.DANH_MUC_HO_SO.SUA,
          component: TrangThemMoiDanhMucHoSo,
          icon: "sign-out-alt",
          isShowLeftMenu: false,
        },
        {
          path:
            ROUTE_NAME.HO_SO_LUU_TRU.DANH_MUC_HO_SO.NAME +
            "/" +
            ROUTE_NAME.HO_SO_LUU_TRU.DANH_MUC_HO_SO.CHI_TIET,
          name: ROUTE_NAME.HO_SO_LUU_TRU.DANH_MUC_HO_SO.CHI_TIET,
          menuName: MENU_ROUTE_NAME.HO_SO_LUU_TRU.DANH_MUC_HO_SO.CHI_TIET,
          component: ChiTietDanhMucHoSo,
          icon: "sign-out-alt",
          isShowLeftMenu: false,
        },
        {
          path:
            ROUTE_NAME.HO_SO_LUU_TRU.TINH_HINH_NOP_DANH_MUC.NAME +
            "/" +
            ROUTE_NAME.HO_SO_LUU_TRU.TINH_HINH_NOP_DANH_MUC.THEM_MOI,
          name: ROUTE_NAME.HO_SO_LUU_TRU.TINH_HINH_NOP_DANH_MUC.THEM_MOI,
          menuName:
            MENU_ROUTE_NAME.HO_SO_LUU_TRU.TINH_HINH_NOP_DANH_MUC.THEM_MOI,
          component: SettingDonViNopDanhMuc,
          icon: "sign-out-alt",
          isShowLeftMenu: false,
        },
        {
          path:
            ROUTE_NAME.HO_SO_LUU_TRU.LAP_HO_SO.NAME +
            "/" +
            ROUTE_NAME.HO_SO_LUU_TRU.LAP_HO_SO.THEM_MOI,
          name: ROUTE_NAME.HO_SO_LUU_TRU.LAP_HO_SO.THEM_MOI,
          menuName: MENU_ROUTE_NAME.HO_SO_LUU_TRU.LAP_HO_SO.THEM_MOI,
          component: TrangTaoMoiHoSo,
          isShowLeftMenu: false,
        },
        // {
        //   path:
        //   ROUTE_NAME.HO_SO_LUU_TRU.LAP_HO_SO.THEM_TAI_LIEU.NAME +
        //   "/" +
        //   ROUTE_NAME.HO_SO_LUU_TRU.LAP_HO_SO.THEM_TAI_LIEU.THEM_MOI,
        //   name: ROUTE_NAME.HO_SO_LUU_TRU.LAP_HO_SO.THEM_TAI_LIEU.THEM_MOI,
        //   menuName: MENU_ROUTE_NAME.HO_SO_LUU_TRU.LAP_HO_SO.THEM_TAI_LIEU.THEM_MOI,
        //   component: ThemTaiLieu,
        // },
      ],
    },
    {
      pathAbsolute: ROUTE_NAME.BAO_CAO.NAME + ROUTE_NAME.BAO_CAO.VAN_BAN_DI,
      path: ROUTE_NAME.BAO_CAO.NAME,
      name: ROUTE_NAME.BAO_CAO.NAME,
      menuName: MENU_ROUTE_NAME.BAO_CAO.NAME,
      component: BaoCao,
      chucNang: "BAO_CAO",
      appName: ["QLVB"],
      icon: "chart-line",
      svgIcon: "report",
      isShowLeftMenu: true,
      expand: false,
      children: [
        {
          path: ROUTE_NAME.BAO_CAO.VAN_BAN_DI,
          name: ROUTE_NAME.BAO_CAO.VAN_BAN_DI,
          menuName: MENU_ROUTE_NAME.BAO_CAO.VAN_BAN_DI,
          component: TrangBaoCaoVanBanDi,
          icon: "sign-out-alt",
          meta: {
            permission: PERMISSION_NAME.VAN_BAN_DI_BAO_CAO,
          },
        },
        {
          path: ROUTE_NAME.BAO_CAO.VAN_BAN_DEN,
          name: ROUTE_NAME.BAO_CAO.VAN_BAN_DEN,
          menuName: MENU_ROUTE_NAME.BAO_CAO.VAN_BAN_DEN,
          component: TrangBaoCaoVanBanDen,
          icon: "download",
          meta: {
            permission: PERMISSION_NAME.UNCHECK,
          },
        },
        {
          path: ROUTE_NAME.BAO_CAO.VAN_BAN_TONG_HOP,
          name: ROUTE_NAME.BAO_CAO.VAN_BAN_TONG_HOP,
          menuName: MENU_ROUTE_NAME.BAO_CAO.VAN_BAN_TONG_HOP,
          component: TrangBaoCaoTongHop,
          icon: "download",
          meta: {
            permission: PERMISSION_NAME.UNCHECK,
          },
        },
        {
          path: ROUTE_NAME.BAO_CAO.NHIEM_VU,
          name: ROUTE_NAME.BAO_CAO.NHIEM_VU,
          menuName: MENU_ROUTE_NAME.BAO_CAO.NHIEM_VU,
          component: TrangBaoCaoNhiemVu,
          icon: "download",
          meta: {
            permission: PERMISSION_NAME.UNCHECK,
          },
        },
      ],
    },
    {
      path: ROUTE_NAME.TRANG_CHU,
      pathAbsolute: ROUTE_NAME.TRANG_CHU,
      name: MENU_ROUTE_NAME.TRANG_CHU,
      menuName: MENU_ROUTE_NAME.THONG_KE,
      component: TrangChu,
      icon: "home",
      svgIcon: "report",
      isShowLeftMenu: true,
      expand: false,
      meta: {
        permissionName: MENU_ROUTE_NAME.TRANG_CHU,
      },
    },
    {
      pathAbsolute:
        ROUTE_NAME.QUAN_TRI_HE_THONG.NAME +
        ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_DANH_MUC_CRUD,
      permissionAbsolute: PERMISSION_NAME.QUAN_LY_DANH_MUC,
      path: ROUTE_NAME.QUAN_TRI_HE_THONG.NAME,
      name: ROUTE_NAME.QUAN_TRI_HE_THONG.NAME,
      menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.NAME,
      component: TrangQuanTriHeThong,
      chucNang: "QUAN_TRI_HE_THONG",
      icon: "cogs",
      svgIcon: "cogs",
      props: true,
      isShowLeftMenu: !IS_DESKTOP,
      appName: ["QLVB", "QLNV"],
      expand: false,
      children: [
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_TEMPLATE,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_TEMPLATE,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_TEMPLATE,
          component: TrangQuanLyTemplate,
          icon: "wrench",
          meta: {
            permission: PERMISSION_NAME.QUAN_LY_TEMPLATE,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_LOG_HE_THONG,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_LOG_HE_THONG,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_LOG_HE_THONG,
          component: TrangDanhSachQuanLyLogHeThong,
          icon: "list-alt",
          meta: {
            permission: PERMISSION_NAME.QUAN_LY_LOG_HE_THONG,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_DANH_MUC_CRUD,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_DANH_MUC_CRUD,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_DANH_MUC_CRUD,
          component: TrangQuanLyDanhMucCRUD,
          icon: "cog",
          meta: {
            permission: PERMISSION_NAME.QUAN_LY_DANH_MUC,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_LOAI_VAN_BAN,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_LOAI_VAN_BAN,
          appName: ["QLVB"],
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_LOAI_VAN_BAN,
          component: TrangDanhSachLoaiVanBan,
          icon: "book",
          meta: {
            permission: PERMISSION_NAME.QUAN_LY_LOAI_VAN_BAN,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_NHOM_LAM_VIEC,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_NHOM_LAM_VIEC,
          appName: ["QLVB"],
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_NHOM_LAM_VIEC,
          component: TrangDanhSachNhomLamViec,
          icon: "book",
          meta: {
            permission: PERMISSION_NAME.QUAN_LY_NHOM_LAM_VIEC,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_DE_MUC,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_DE_MUC,
          appName: ["QLVB"],
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_DE_MUC,
          component: TrangDanhSachDeMuc,
          icon: "book",
          meta: {
            permission: PERMISSION_NAME.UNCHECK,
          },
          isShowLeftMenu: false,
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_LINH_VUC,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_LINH_VUC,
          appName: ["QLVB"],
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_LINH_VUC,
          component: TrangQuanLyLinhVuc,
          icon: "book",
          meta: {
            permission: PERMISSION_NAME.UNCHECK,
          },
          isShowLeftMenu: false,
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_LOAI_SO_VAN_BAN,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_LOAI_SO_VAN_BAN,
          appName: ["QLVB"],
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_LOAI_SO_VAN_BAN,
          component: TrangDanhSachLoaiSoVanBan,
          icon: "book",
          meta: {
            permission: PERMISSION_NAME.QUAN_LY_LOAI_SO_VAN_BAN,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_SO_VAN_BAN,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_SO_VAN_BAN,
          appName: ["QLVB"],
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_SO_VAN_BAN,
          component: TrangDanhSachSoVanBan,
          icon: "book",
          meta: {
            permission: PERMISSION_NAME.QUAN_LY_SO_VAN_BAN,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_DON_VI_NGOAI,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_DON_VI_NGOAI,
          appName: ["QLVB"],
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_DON_VI_NGOAI,
          component: TrangDanhSachDonViNgoai,
          icon: "city",
          meta: {
            permission: PERMISSION_NAME.QUAN_LY_DON_VI_NGOAI,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_NHOM_CONG_VIEC,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_NHOM_CONG_VIEC,
          appName: ["QLVB"],
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_NHOM_CONG_VIEC,
          component: TrangQuanLyNhomCongViec,
          meta: {
            permission: PERMISSION_NAME.QUAN_LY_NHOM_DON_VI_CA_NHAN,
          },
          icon: "list-alt",
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_MAU_DU_THAO.DANH_SACH,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_MAU_DU_THAO.DANH_SACH,
          appName: ["QLVB"],
          menuName:
            MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_MAU_DU_THAO.DANH_SACH,
          isShowLeftMenu: true,
          icon: "list-alt",
          component: TrangQuanLyMauDuThao,
          meta: {
            permission: PERMISSION_NAME.QUAN_LY_MAU_DU_THAO,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_MAU_DU_THAO.XEM,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_MAU_DU_THAO.XEM,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_MAU_DU_THAO.XEM,
          isShowLeftMenu: false,
          icon: "list-alt",
          component: TrangChiTietMauDuThao,
          meta: {
            permission: PERMISSION_NAME.QUAN_LY_MAU_DU_THAO,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_MAU_DU_THAO.TAO,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_MAU_DU_THAO.TAO,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_MAU_DU_THAO.TAO,
          isShowLeftMenu: false,
          icon: "list-alt",
          component: TrangChiTietMauDuThao,
          meta: {
            permission: PERMISSION_NAME.QUAN_LY_MAU_DU_THAO,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.CAU_HINH_HE_THONG,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.CAU_HINH_HE_THONG,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CAU_HINH_HE_THONG,
          isShowLeftMenu: true,
          icon: "cog",
          component: TrangCauHinhHeThong,
          meta: {
            permission: PERMISSION_NAME.CAU_HINH_HE_THONG,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_DON_VI_NOP_LUU,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_DON_VI_NOP_LUU,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_DON_VI_NOP_LUU,
          isShowLeftMenu: false,
          icon: "cog",
          component: TrangQuanLyDonViNopLuu,
          meta: {
            permission: PERMISSION_NAME_HSLT.HSLT_QUAN_LY_DON_VI_NOP_LUU,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_UY_QUYEN,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_UY_QUYEN,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.QUAN_LY_UY_QUYEN,
          appName: ["QLVB"],
          component: TrangQuanLyUyQuyen,
          meta: {
            permission: PERMISSION_NAME.QUAN_LY_UY_QUYEN,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.CAU_HINH_UY_QUYEN,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.CAU_HINH_UY_QUYEN,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CAU_HINH_UY_QUYEN,
          appName: ["QLVB"],
          component: TrangCauHinhUyQuyen,
          meta: {
            permission: PERMISSION_NAME.CAU_HINH_UY_QUYEN,
          },
        },
        {
          path: ROUTE_NAME.QUAN_TRI_HE_THONG.VAN_BAN_ERROR,
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.VAN_BAN_ERROR,
          menuName: MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.VAN_BAN_ERROR,
          component: TrangVanBanBiLoi,
          icon: "sync-alt",
          meta: {
            permission: PERMISSION_NAME.XEM_VAN_BAN_LOI_BAN_HANH,
          },
        },
        {
          path: ROUTE_NAME.VAN_BAN_DI.XEM,
          name: ROUTE_NAME.VAN_BAN_DI.XEM,
          isShowLeftMenu: false,
          component: ChiTietVanBanDi,
          meta: {
            permission: PERMISSION_NAME.XEM_VAN_BAN_LOI_BAN_HANH,
          },
        },
      ],
    },
    {
      path: ROUTE_NAME.HE_THONG,
      name: ROUTE_NAME.HE_THONG,
      menuName: MENU_ROUTE_NAME.HE_THONG,
      component: HeThong,
      isShowLeftMenu: false,
      expand: false,
      icon: "",
    },
    {
      path: ROUTE_NAME.CHUC_VU.DANH_SACH,
      name: ROUTE_NAME.CHUC_VU.DANH_SACH,
      menuName: MENU_ROUTE_NAME.CHUC_VU.DANH_SACH,
      component: TrangDanhSachNhomChucVu,
      isShowLeftMenu: false,
      expand: false,
      icon: "",
    },
    {
      path: ROUTE_NAME.CHUC_VU.CAP_NHAT,
      name: ROUTE_NAME.CHUC_VU.CAP_NHAT,
      menuName: MENU_ROUTE_NAME.CHUC_VU.CAP_NHAT,
      component: TrangCapNhatNhomChucVu,
      isShowLeftMenu: false,
      icon: "",
    },
    {
      path: ROUTE_NAME.CHUC_VU.CHI_TIET,
      name: ROUTE_NAME.CHUC_VU.CHI_TIET,
      menuName: MENU_ROUTE_NAME.CHUC_VU.CHI_TIET,
      component: TrangChiTietNhomChucVu,
      isShowLeftMenu: false,
      icon: "",
    },
  ],
});
router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = [ROUTE_NAME.DANG_NHAP];
  const forwardPages = [
    ROUTE_NAME.VAN_BAN_DEN.XEM_LUONG,
    ROUTE_NAME.VAN_BAN_DI.XEM_LUONG,
    ROUTE_NAME.NHIEM_VU.XEM_LUONG,
    ROUTE_NAME.REDIRECT,
  ];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = getValueFromStorageByKey(LOCAL_STORAGE_KEY.ACCESS_TOKEN);

  const permissionName = to && to.meta && to.meta.permissionName;
  setValueToStorageByKey(LOCAL_STORAGE_KEY.PERMISSION_NAME, permissionName);
  let hasPer =
    hasPermissionUser(to && to.meta && to.meta.permission) ||
    (to.meta && to.meta.permission) === PERMISSION_NAME.UNCHECK;
  if (to.path.includes("van-ban-den")) {
    if (to.name === "cho-vao-so") {
      hasPer = to.meta.permission.some((per) => hasPermissionUser(per));
    } else {
      hasPer = true;
    }
  }
  if (forwardPages.includes(to.name)) {
    next();
    return;
  }

  if (authRequired && !loggedIn) {
    store.dispatch("common/setIsLogin", false);
    return next(ROUTE_NAME.DANG_NHAP);
  } else if (!authRequired && loggedIn) {
    return next(ROUTE_NAME.VAN_BAN_DEN.CHO_XU_LY);
  } else if (!hasPer) {
    return next(ROUTE_NAME.CHUA_CO_QUYEN);
  }

  next();
});

export default router;
